import React, { Component } from 'react'
import { Tenant } from 'models/Blip/Index'
import { Icon, Card, Table } from 'antd'
import { SearchTable } from 'components/SearchTable'
import { getApplications } from 'services/CeberusApiService'
import { TenantService } from 'connection/TenantService'
import { SearchOrganizationRequest } from 'models/request/Index'
import { ApplicationsResponse, SearchOrganizationResponse } from 'models/response/Index'
import { PushNotification } from 'utils/PushNotification'

const { Column } = Table;

const handleSearch = (selectedKeys: string, confirm: Function) => () => {
  confirm();
}
    
const handleReset = (clearFilters: Function) => () => {
  clearFilters();
}

export class OrganizationApplications extends Component<SearchOrganizationResponse> {
    state = {
      isLoading: false,
      isModalLoading: false,
      isModalVisible: false,
      tenantSelected: new Tenant(),
      applications: new Array<ApplicationsResponse>()
    }
    
    async componentDidMount() {
      this.loadPage();
    }

    loadPage = async () => {
      try {
        const tenantSelected = TenantService.getSelectedTenant();
        this.setState({ tenantSelected, isLoading: true });

        if (!this.props.Id) {
          return;
        }

        const request = new SearchOrganizationRequest();
        request.OrganizationId = this.props.Id;
        request.ClusterName = tenantSelected.name;
  
        const applications = await getApplications(request);
          
        this.setState({ applications });
      } catch (error) {
        PushNotification.httpError(error);
      }finally{
        this.setState({ isLoading: false });
      }
    }

    render() {
      const cardTitle = `Total of applications on ${this.props.Name}: ${this.state.applications.length}`;

      let searchInput;

      return (
        <div className="mt5 w-100">
          <Card title={cardTitle} className="mb3" loading={this.state.isLoading}>
            <Table dataSource={this.state.applications} rowKey="shortName">
              <Column 
                title='ShortName'
                dataIndex='shortName'
                sorter={(a:ApplicationsResponse, b:ApplicationsResponse) => a.shortName.localeCompare(b.shortName)}
                onFilter={(value, record:ApplicationsResponse) => record.shortName.toString().includes(value.toString())}filterIcon={(filtered) => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />}
                onFilterDropdownVisibleChange={(visible) => visible && setTimeout(() => searchInput.focus())}
                filterDropdown={({
                  setSelectedKeys, selectedKeys, confirm, clearFilters,
                }) => (
                  <SearchTable
                    onSetRef={e => (searchInput = e)}
                    onSetSelectedKeys={setSelectedKeys}
                    selectedKeys={selectedKeys}
                    confirm={confirm}
                    clearFilters={clearFilters}
                    onSearch={handleSearch}
                    onReset={handleReset}
                  />
                )}/>
              <Column 
                title='Name'
                dataIndex='name'/>
              <Column 
                title='Description'
                dataIndex='description'/>
              <Column 
                title='Template'
                dataIndex='template'/>
              <Column 
                title='TenantId'
                dataIndex='tenantId'/>
              <Column 
                title='Created'
                dataIndex='created'/>
              <Column 
                title='Updated'
                dataIndex='updated'/>
            </Table>
          </Card>
        </div>
      )
    }
}